<template>
  <div>
    <el-input
        v-model="inputValue"
        :controls="false"
        type="number"
        :placeholder="'单位('+inputUnit+')'"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "qualityInput",
  props: {
    value: {
      type: String,
      default: ''
    },
    inputUnit: {
      type: String,
      default: 'ng'
    },
    realUnit: {
      type: String,
      default: 'ng'
    },
    fixedDecimal: {
      type: Number,
      default: 0
    }
  },
  computed: {
    displayValue() {
      return this.baseMethods.qualityConverter(this.inputValue / 1,this.inputUnit, this.realUnit, this.fixedDecimal)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val){
        this.inputValue = this.baseMethods.qualityConverter(val / 1,this.realUnit, this.inputUnit, this.fixedDecimal)
      }
    },
    inputValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', this.displayValue / 1)
      }
    }
  },
  mounted() {
    this.inputValue = this.baseMethods.qualityConverter(this.value / 1,this.realUnit, this.inputUnit, this.fixedDecimal)
  },
  data() {
    return {
      inputValue: ''
    }
  }
}
</script>

<style scoped>
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ input[type="number"]{
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/qualityInput.vue